<template>
  <div class="noticeContainer">
    <div class="noticeIcon" @click="openPopup">
      <van-badge :content="msgList.length">
        <img src="~@/assets/icons/icon_alarm.png"/>
      </van-badge>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import DOMPurify from 'dompurify';
import {_code} from "@utils/constant";
export default {
  name: "Notice",
  computed: {
    ...mapGetters(["live"]),
    purifiedHtml() {
      return DOMPurify.sanitize(this.live.notice);
    }
  },
  data: function () {
    return {
      showNotice: false,
      msgList:[]
    }
  },
  created() {
    this.queryMsg();
  },
  mounted() {
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  methods: {
    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.RESPONSE_EXCHANGE_CARD: // 回复交换名片
        case _code.SEND_EXCHANGE_CARD: // 交换名片请求
        case _code.SEND_NOTICE: // 发通知

          this.queryMsg();
          break;
      }
    },
    queryMsg(){
      this.$http.get(`/message/queryUnReadLiveMsg?liveId=${this.live.id}`).then(res=>{
        this.msgList = res.data
      })
    },
    openPopup() {
      this.$Bus.$emit("openUnReadMsg", this.msgList);
      this.showNotice = false;
    },
    closePopup() {
      this.showNotice = false
    },
    // confirm(){
    //   this.$http.post('/api/dlrLiveUser/confirmNotice',{id:this.live.id}).then(()=>{
    //     this.showNotice = false
    //   })
    // }
  }
};
</script>

<style lang="less" scoped>
.noticeIcon {
  position: fixed;
  top: 47px; /* 原94px */
  left: 14px; /* 原28px */
  padding: 0 10px; /* 原20px */
  height: 38px; /* 原75px */
  border-radius: 9px; /* 原18px */
  display: flex;
  align-items: center;
  font-size: 11px; /* 原22px */
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 13px; /* 原26px */
  color: rgba(0, 0, 0, 0.58);
  z-index: 1;

  img {
    width: 25px; /* 原50px */
  }
}

.popup-wrap {
  padding: 10px; /* 原20px */
  font-size: 12px; /* 原24px */
  width: 300px; /* 原600px */

  /* 头部样式 */
  .popup-header {
    padding: 8px 10px; /* 原15px 20px */
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .popup-close {
    font-size: 18px; /* 原36px */
    cursor: pointer;
  }

  /* 内容区 */
  .popup-body {
    padding: 10px; /* 原20px */
    text-align: center;
    max-height: 60vh;
    overflow-y: auto;
  }

  /* 底部按钮 */
  .popup-footer {
    padding: 8px; /* 原15px */
    text-align: center;
  }

  .confirm-btn {
    padding: 5px 15px; /* 原10px 30px */
    background: #FF6B95;
    color: white;
    border: none;
    border-radius: 13px; /* 原25px */
    cursor: pointer;
  }
}
</style>
